import Backoffice from "@snark/backoffice"

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
	user: Backoffice.populator("user", {
		displayProperty: item => {
			return item.firstname + " " + item.lastname;
		},
	}),
	group: Backoffice.populator("group", {}),
};

export default {
	name: "account",
	collection: "account",
	idProperty: "_id",
	section: "app",
	labels: { "singleTitle": "Account", "listTitle": "Accounts" },
	emptyItem: { "members": [], billingType: "default", subscriptionIsCustom: false },
	fields: [
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "name",
			label: "Name",
		},
		{
			name: "status",
			label: "Status",
			formatter: Backoffice.formatters.mapping({ "created": "Created" }),
			editor: { type: "select", options: [{ value: "created", label: "Created" }] },
		},
		{
			name: "billingType",
			label: "Type d'utilisation",
			extra: "Default = usage libre comme avant la mise en place des crédits/abonnements (aucun crédit, aucun abonnement, aucune activation/désactivation de site).",
			formatter: Backoffice.formatters.mapping({ "default": "Default (sans crédit)", "purchase": "Achat", "subscription": "Abonnement" }),
			editor: {
				type: "select",
				options: [
					{ value: "default", label: "Default (sans crédit)" },
					{ value: "purchase", label: "Achat" },
					{ value: "subscription", label: "Abonnement" },
				]
			},
		},
		{
			name: "subscriptionIsCustom",
			label: "Abonnement personnalisé (géré par site)",
			extra: "Si activé, le nombre de mois se règle building par building (ignore le champ ci-dessous).",
			editor: { type: "boolean" },
		},
		{
			name: "subscriptionStartAt",
			label: "Début de la période d'abonnement",
			extra: "Laisser vide si l'abonnement couvre l'année complète. Ignoré si abonnement personnalisé.",
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
			editor: { type: "date" },
		},
		{
			name: "subscriptionEndAt",
			label: "Fin de la période d'abonnement",
			extra: "Laisser vide si l'abonnement couvre l'année complète. Ignoré si abonnement personnalisé.",
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
			editor: { type: "date" },
		},
		{
			name: "members",
			label: "Members",
			list: true,
			emptyItem: {
				userId: null,
				role: "everyone",
				groupIds: [],
			},
			children: [
				{
					name: "userId",
					label: "User Id",
					formatter: Backoffice.formatters.linkObjectId("user", { idProperty: "_id", label: context.user.formatter() }),
					editor: context.user.editor(),
				},
				{
					name: "role",
					label: "Role",
					editor: {
						type: "select",
						options: [
							{ value: "everyone", label: "Everyone" },
							{ value: "admin", label: "Admin" },
							{ value: "support", label: "Support" }
						]
					},
					// quand on change le rôle, on vide groupIds si admin
					transform: (value, item) => {
						if (value === "admin" || value === "support") {
							item.groupIds = [];
						}
						return value;
					}
				},
				{
					name: "groupIds",
					label: "Groups",
					list: true,
					editor: {
						type: "checks",
						watch: "role",
						// options réactif à field.object.role
						options: (field) => {
							if (field.object?.role === "admin" || field.object?.role === "support") {
								// masquer les groupes pour les admins/support
								return Promise.resolve([]);
							}

							const accountId = field.parent?._id;

							return Promise.resolve(
								(context.group.items || [])
									.filter(g => !accountId || String(g.accountId) === String(accountId))
									.map(g => ({
										value: g._id,
										label: g.name,
									}))
							);
						},
					},
					formatter: Backoffice.formatters.linkObjectId("group", {
						idProperty: "_id",
						label: context.group.formatter(),
					}),
					transform: (value, item) => {
						let ids = [];
						if (Array.isArray(value)) {
							ids = value.map(v => v.value ?? v);
						}
						else if (value && value !== true) {
							ids = [value.value ?? value];
						}
						item.groupIds = ids;
						return ids;
					},
				},
			]
		},
		{
			name: "state",
			label: "State",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.mapping({ "deleted": "Deleted", "draft": "Draft" }),
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "name",
			label: "Name",
		},
		{
			name: "billingType",
			label: "Type d'utilisation",
			formatter: Backoffice.formatters.mapping({ "default": "Default (sans crédit)", "purchase": "Achat", "subscription": "Abonnement" }),
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	loadSingle() {
		context.user.items = null;
		context.group.items = null;
		return Promise.all([
			context.user.load(),
			context.group.load(),
		]);
	}

};
